import React, { Component } from 'react';
import s from './input.scss';
import cx from 'classnames';

class Input extends Component {
  constructor(props) {
    super(props);
    this.state = {
      state: ''
    };
  }

  inputCreated = el => {
    this.inputElement = el;
  };

  focus() {
    if (this.inputElement) {
      this.inputElement.focus();
    }
  }

  onInputBlur = () => {
    this.setState({ state: '', showIndicator: false });
  };

  onInputFocus = () => {
    const { onFocus } = this.props;
    this.setState({ state: s.focus, showIndicator: true });
    if (onFocus) {
      onFocus();
    }
  };

  render() {
    const { text, placeholder, onChange, limit, inputProps = {}, id, dataAid } = this.props;
    const { state } = this.state;

    const classes = cx(s.container, state);

    let onBlurFunc = this.onInputBlur;
    let onFocusFunc = this.onInputFocus;
    let onChangeFunc = onChange;

    if (inputProps && inputProps.onBlur) {
      onBlurFunc = e => {
        this.onInputBlur(e);
        inputProps.onBlur(e);
      };
    }

    if (inputProps && inputProps.onFocus) {
      onFocusFunc = e => {
        this.onInputFocus(e);
        inputProps.onFocus(e);
      };
    }

    if (inputProps && inputProps.onChange) {
      onChangeFunc = e => {
        onChange(e);
        inputProps.onChange(e);
      };
    }

    const { onBlur, value, onFocus, onChange: onChange2, ...finalInputProps } = inputProps; //eslint-disable-line

    return (
      <div style={{ display: 'flex', flexDirection: 'column', position: 'relative', height: '30px' }}>
        <div className={classes}>
          <input
            type="text"
            autoComplete="off"
            data-aid={dataAid}
            ref={this.inputCreated}
            id={id}
            placeholder={placeholder || ''}
            maxLength={limit}
            {...finalInputProps}
            onBlur={onBlurFunc}
            onFocus={onFocusFunc}
            onChange={onChangeFunc}
            value={text}
          />
        </div>
      </div>
    );
  }
}

Input.defaultProps = {
  forceHideIndicator: true
};

export default Input;
